import React from 'react';
import { IconButton } from '@mui/material';
import { KeyboardArrowDown as ChevronIcon } from '@mui/icons-material';

type Props = {
  isCollapsed: boolean;
  onToggle: () => void;
  size?: 'small' | 'medium' | 'large';
  color?: string;
};

function ExpandCollapseIcon({ isCollapsed, onToggle, size = 'small', color = '#666' }: Props) {
  return (
    <IconButton
      size={size}
      onClick={onToggle}
      sx={{
        padding: '4px',
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      <ChevronIcon
        fontSize={size}
        sx={{
          transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease',
          color: color
        }}
      />
    </IconButton>
  );
}

export default ExpandCollapseIcon;
